import { PaginatedResponse, PaginationType, SearchParams } from "helpers";
import { api } from "services";
import { imageToFormData, postImage } from "services/images";

import { reviewToBody, resToReview } from "./transformations";
import { Review } from "./types";

export const getReviews = async (
  pagination: PaginationType,
  search: SearchParams
): Promise<PaginatedResponse<Review>> => {
  const params = [
    `pageNumber=${pagination.currentPage}`,
    `pageSize=${pagination.pageSize}`,
    `sortBy=${search.sortBy}`,
    `desending=${search.descending}`,
    `search=${search.search}`,
  ];
  const url = `/reviews?${params.join("&")}`;
  const resp = await api.get(url);
  return { data: resp.data.data.map(resToReview), meta: resp.data.meta };
};

export const getReview = async (id: number): Promise<Review> => {
  const resp = await api.get(`/reviews/${id}`);
  return resToReview(resp.data);
};

export const putReview = async (data: Review): Promise<Review> => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = reviewToBody(data);
  const resp = await api.put(`/reviews/${data.id}`, body);
  return resToReview(resp.data);
};

export const postReview = async (data: Review) => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = reviewToBody(data);
  const resp = await api.post(`/reviews`, body);
  return resToReview(resp.data);
};

export const publishReview = async (id: number, published: boolean) => {
  const resp = await api.put(`reviews/${id}/publish`, { published });
  return resToReview(resp.data);
};

export const deleteReview = async (id: number): Promise<void> => {
  await api.delete(`/reviews/${id}`);
};
